module.exports = __webpack_public_path__ + "img/02_1_2_2.f5b1bfa1.png";